export default {
    methods: {
        makeTableHeadersFocusableByTab(dataTable) {
            this.$nextTick(function () {
                const ths = dataTable.querySelectorAll('th.sortable');
                ths.forEach(th => {
                    th.setAttribute('tabindex', '0');
                    th.setAttribute('role', 'button');

                    th.removeEventListener('keydown', th._onKeydownSort);

                    th._onKeydownSort = function (e) {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            th.click();
                        }
                    };
                    th.addEventListener('keydown', th._onKeydownSort);
                });
            });
        }
    }
}
